import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RoutePaths } from "src/constants";



export const LeadsTableActionMenu = ({ closeMenu, row }) => {
  const navigate = useNavigate();
// debugger;
const isCustomer = String(row.original.IsCustomer).toLowerCase() === 'true';
   
  
    return [
      <MenuItem
        key={1}
    
        onClick={() => {
          if(!isCustomer){
          closeMenu();
          navigate(`${RoutePaths.CREATE_LEAD}/${row.original.id}`);
          }
        }}
        disabled={isCustomer}
        sx={{ m: 0 }}
      >
        Update Lead
      </MenuItem>,
     
    ];
  };
  